import React, { useEffect } from 'react';
import DevicesPage from './devices/DevicesPage';
import './users/users.css';
import './users/brand.css';
import './devices/devices.css';
export default function DeviceManagement() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <DevicesPage />;
}
